
/**
 * 구독 초기화 요청 (새로운 간소화된 스키마)
 */
export type InitiateSubscriptionBody = {
  /** 주문 ID (주문 정보에서 userId, productName, amount, planId 등을 조회) */
  orderId: string;
  /** 결제 수단 ID (등록된 카드 ID) */
  paymentMethodId: string;
};
